import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronDown } from "lucide-react";

const FAQS = [
  { q: "Is Zenith Flow Dynamics an investment platform?", a: "No. Zenith is a Commerce-as-a-Service platform. Partners earn by selling real products, not by depositing capital. There is no daily yield, no ROI, and no passive income promise." },
  { q: "How do I make money on Zenith?", a: "Three ways: (1) Retail profit — buy at partner wholesale price and keep the retail margin on every sale. (2) Direct referral bonus when you enroll new partners. (3) Team overrides on qualifying product sales in your team down to 5 levels deep." },
  { q: "Do I need to buy inventory?", a: "Never. You promote products from our catalog using your personal online store. When a customer orders, Zenith ships directly to them. You never handle stock." },
  { q: "Where does Zenith ship?", a: "Nationwide across the Philippines. Every order is tracked from checkout to doorstep in your partner dashboard." },
  { q: "How do I get paid?", a: "Commissions land in your Commission Wallet as they clear. You can withdraw anytime to your bank account or e-wallet — no lock-up cycles, no waiting periods." },
  { q: "What is the difference between the membership tiers?", a: "Starter Partner gets up to 10% retail margin. Business Builder gets up to 18% and access to team overrides levels 1-3. Executive Partner gets up to 25% margin plus full 5-level team override tree and priority payouts." },
  { q: "Do I need experience to start?", a: "No experience required. Every partner gets full access to the Marketing Academy, AI content tools, and 24/7 support. You can start selling the day you activate your kit." },
  { q: "Are earnings guaranteed?", a: "No. Earnings vary based on your sales performance and are not guaranteed. Everything in our compensation plan is funded by real product transactions." },
  { q: "How do refunds work?", a: "Customers can request refunds through your dashboard's order management screen. Refunds follow standard consumer protection guidelines and are processed by our fulfillment team." },
  { q: "What is a Business Starter Kit?", a: "It's your entry package into Zenith. It includes activation for your personal online store, your affiliate dashboard, marketing materials, AI assistant access, wholesale pricing, and a sample of physical products depending on tier." },
];

function Item({ q, a, idx }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div className="glass-card overflow-hidden" data-testid={`faq-item-${idx}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 hover:bg-white/[0.02]"
        data-testid={`faq-toggle-${idx}`}
      >
        <span className="font-display font-black text-white text-sm md:text-base">{q}</span>
        <ChevronDown size={18} className={`shrink-0 text-[#FBBF24] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-5 pb-5 text-sm text-white/70 leading-relaxed" data-testid={`faq-answer-${idx}`}>
          {a}
        </div>
      )}
    </div>
  );
}

export default function Faq() {
  return (
    <div className="space-y-6" data-testid="faq-page">
      <div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-3">
          <Sparkles size={12} /> Frequently Asked Questions
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight max-w-3xl">
          Everything you want to know about building a business with{" "}
          <span className="text-[#FBBF24]">Zenith.</span>
        </h1>
      </div>

      <div className="space-y-3">
        {FAQS.map((f, i) => <Item key={f.q} q={f.q} a={f.a} idx={i} />)}
      </div>

      <div className="glass-card gold-border p-6 mt-8 text-center">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#FBBF24] font-bold mb-1">Still have questions?</div>
        <div className="font-display text-xl font-black">Our support team replies within one business hour.</div>
        <Link to="/contact" className="btn-deploy mt-4 inline-flex items-center gap-2 px-6 py-2.5 rounded-md text-sm font-bold uppercase tracking-widest" data-testid="faq-contact-cta">
          Contact Support
        </Link>
      </div>
    </div>
  );
}
